export default {
      id: "i-lk-nav-input-client-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/sprite.svg#i-lk-nav-input-client",
      toString: function () {
        return this.url;
      }
    }